class HomepageBanner {
  constructor (data) {
    this.id = data ? data.id : ''
    this.title = data ? data.title : ''
    this.image = data ? data.image : ''
    this.imageUrl = data ? data.imageUrl : ''
    this.description = data ? data.description : ''
    this.created_at = data ? data.created_at : ''
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('title', this.title)
    formData.append('image', this.image)
    formData.append('description', this.description)
    return formData
  }
}

export default HomepageBanner



// WEBPACK FOOTER //
// ./src/models/HomepageBanner.js